import axios from 'axios';
// import moment from 'moment';

import {
    GET_ACCOMMODATIONS,
    GET_ACCOMMODATION,
    GET_ERRORS,
    SET_LOADING,
    FILTER_ROOMS_ACCOMM,
    CLEAR_AVAIL_ROOMS,
    BOOK_ACCOMM,
    GET_PAYMENT_INFO,
    SAVE_USER_BOOKING,
    CLEAR_ERRORS
} from './types';

import { API_ENDPOINT } from '../config/constants';

export const getAccommodations = () => dispatch => {
    dispatch(setLoading());

    axios.get(API_ENDPOINT+'/accomodations')
        .then(res =>{
            dispatch({
                type: GET_ACCOMMODATIONS,
                payload: res.data.accomodations
            });

            // setTimeout(() => {
            //     for (let i=0; i<res.data.accomodations.length; i++) {
            //         let actualAccommodation = res.data.accomodations[i];
            //         if (!!actualAccommodation.full_lease && !!actualAccommodation.bookings && actualAccommodation.bookings.length>0) {
            //             for (let j=0; j<actualAccommodation.bookings.length; j++) {
            //                 let actualBooking = actualAccommodation.bookings[j];
            //                 if (moment(actualBooking.start).isAfter(moment())) {
            //                     console.log("FULL LEASE: ", actualAccommodation.name);
            //                     console.log(moment(actualBooking.start).format("DD/MM/YYYY"), " a ", moment(actualBooking.end).format("DD/MM/YYYY"));
            //                 }
            //             }
            //         } else if (!!actualAccommodation.rooms && actualAccommodation.rooms.length>0) {
            //             for (let j=0; j<actualAccommodation.rooms.length; j++) {
            //                 let actualRoom = actualAccommodation.rooms[j];
            //                 if (!!actualRoom.bookings && actualRoom.bookings.length>0) {
            //                     for (let k=0; k<actualRoom.bookings.length; k++) {
            //                         let actualBooking = actualRoom.bookings[k];
            //                         if (moment(actualBooking.start).isAfter(moment())) {
            //                             console.log("FOR ROOMS: ", actualAccommodation.name, " ", actualRoom.name);
            //                             console.log(moment(actualBooking.start).format("DD/MM/YYYY"), " a ", moment(actualBooking.end).format("DD/MM/YYYY"), " personas: ", actualBooking.persons);
            //                         }
            //                     }
            //                 }
            //             }
            //         } else {
            //             if (!!actualAccommodation.bookings) console.log("actualAccommodation.bookings.length: ",actualAccommodation.bookings.length);
            //             if (!!actualAccommodation.rooms) console.log("actualAccommodation.rooms.length: ", actualAccommodation.rooms.length);
            //             console.error("Problema recorriendo los bookings del Alojamiento ", actualAccommodation.name);
            //         }
            //     }
            // }, 3000);
        })
        .catch(err => {
            console.log(err);
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        });
};

export const getAccommodation = id => dispatch => {
    dispatch(setLoading());

    axios.get(API_ENDPOINT+`/accomodations/${id}`)
        .then(res =>
            dispatch({
                type: GET_ACCOMMODATION,
                payload: res.data.accomodation
            })
        )
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const filterRoomsAccommodation = filterData => dispatch => {
    dispatch(clearErrors());

    axios.get(API_ENDPOINT+`/accomodations/${filterData.accommodationId}/rooms`, {params: filterData})
        .then(res =>
            dispatch({
                type: FILTER_ROOMS_ACCOMM,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const clearAvailableRooms = () => dispatch => {
    dispatch({
        type: CLEAR_AVAIL_ROOMS,
        payload: null // Do nothing
    })
};

export const bookAccommodation = bookingInfo => dispatch => {
    dispatch(clearErrors());

    axios.post(API_ENDPOINT+`/booking/accomodations/${bookingInfo.accommodationId}`, bookingInfo)
        .then(res => {
            dispatch({
                type: BOOK_ACCOMM,
                payload: res.data.booked
            });

            let bookingIds = { booked: res.data.booked };

            axios.post(API_ENDPOINT+`/booking/accomodations/${bookingInfo.accommodationId}/create-payment`, bookingIds)
                .then(resP => {
                    dispatch({
                        type: GET_PAYMENT_INFO,
                        payload: resP.data.payment_info
                    });
                    localStorage.setItem('BOOKING_IDS', JSON.stringify(res.data));
                    localStorage.setItem('PAYMENT_INFO', JSON.stringify(resP.data.payment_info));

                    // let paymentInfo = resP.data.payment_info;
                    // let data = {
                    //     merchantId:  paymentInfo.merchantId,
                    //     accountId: paymentInfo.accountId,
                    //     description: !!bookingInfo.persons ?
                    //         (!!bookingInfo.roomsInfo && bookingInfo.roomsInfo.length===1) ?
                    //             `${paymentInfo.description}, ${bookingInfo.accommodationName}, ${bookingInfo.roomsInfo[0].name}, ${bookingInfo.persons} huéspedes, ${bookingInfo.start} - ${bookingInfo.end}`
                    //             :
                    //             `${paymentInfo.description}, ${bookingInfo.accommodationName}, ${bookingInfo.persons} huéspedes, ${bookingInfo.start} - ${bookingInfo.end}`
                    //         :
                    //         `${paymentInfo.description}, ${bookingInfo.accommodationName}, ${bookingInfo.start} - ${bookingInfo.end}`,
                    //     referenceCode: paymentInfo.referenceCode,
                    //     amount: paymentInfo.amount,
                    //     // tax: paymentInfo.tax,
                    //     // taxReturnBase: paymentInfo.taxReturnBase,
                    //     currency: paymentInfo.currency,
                    //     signature: paymentInfo.signature,
                    //     test: paymentInfo.test,
                    //     buyerEmail: userInfo.email,
                    //     buyerFullName: `${userInfo.first_name} ${userInfo.last_name}`,
                    //     payerDocument: userInfo.documentNumber,
                    //     responseUrl: paymentInfo.responseUrl,
                    //     confirmationUrl: paymentInfo.confirmationUrl
                    // };
                    //
                    // console.log('data: ', data);
                    //
                    //
                    // axios.post(paymentInfo.serviceUrl, data)
                    //     .then(resP2 =>
                    //         history.push(paymentInfo.serviceUrl)
                    //     )
                    //     .catch(err =>
                    //         history.push(paymentInfo.serviceUrl)
                    //     )
                })
                .catch(err =>
                    dispatch({
                        type: GET_ERRORS,
                        payload: err.response.data
                    })
                );
        })
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const saveUserBooking = userInfo => dispatch => {
    dispatch(clearErrors());

    axios.put(API_ENDPOINT+`/tourist/${userInfo._id}`, userInfo)
        .then(res =>
            dispatch({
                type: SAVE_USER_BOOKING,
                payload: res.data
            })
        )
        .catch(err =>
            dispatch({
                type: GET_ERRORS,
                payload: err.response.data
            })
        );
};

export const setLoading = () => {
    return {
        type: SET_LOADING
    }
};

/**
 * TODO: Revisar el aspecto de mostrar/limpiar errores de formulario
 */

export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    }
};


// WEBPACK FOOTER //
// ./src/actions/accommodationsActions.js